import Swiper, { Autoplay, Controller, EffectCreative, Navigation } from "swiper";

document.addEventListener('DOMContentLoaded', () => {
  //todo:Весь код взят из history.js
  //todo:Уже поменял navPrev и navNext
  //todo:Так же поменял классы для слайдера и thumbs

  const wheelSwiper = document.querySelector('.wheel-slider')
  const navPrev = document.querySelector('.wheel-slider__control--prev')
  const navNext = document.querySelector('.wheel-slider__control--nav')
  const wheelPagination = document.querySelector('.wheel__thumbs')

  if (wheelSwiper) {
    let wheelSlider = new Swiper(wheelSwiper, {
      modules: [Navigation, EffectCreative, Autoplay, Controller],
      effect: "creative",
      speed: 1000,
      parallax: true,
      allowTouchMove: false,
      spaceBetween: 2,
      loop: true,
      creativeEffect: {
        prev: {
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      navigation: {
        nextEl: navNext,
        prevEl: navPrev
      },
      breakpoints: {
        999: {
          allowTouchMove: false
        },
        0: {
          allowTouchMove: true
        }
      }
    });

    let paginations = wheelPagination.querySelectorAll('.thumbs__item')

    const scrollBlock = () => {
      if (window.innerWidth <= 999) {
        wheelPagination.scrollTo({
          left: paginations[wheelSlider.realIndex].offsetLeft - 20,
          behavior: 'smooth'
        })
      }
    }

    const createPagination = () => {
      paginations[0].classList.add('thumbs__item--active')

      paginations.forEach((pagination, index) => {
        pagination.addEventListener('click', () => {
          throttle = true
          wheelSlider.slideTo(index + 1)
        })
      })
    }
    createPagination()
    let activeIndex = 0

    const initSlider = () => {
      const wheelSwiper = document.querySelector('.wheel-slider')
      wheelSlider = new Swiper(wheelSwiper, {
        modules: [Navigation, EffectCreative, Autoplay, Controller],
        effect: "creative",
        speed: 1000,
        parallax: true,
        allowTouchMove: false,
        spaceBetween: 2,
        loop: true,
        creativeEffect: {
          prev: {
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        navigation: {
          nextEl: navNext,
          prevEl: navPrev
        },
        breakpoints: {
          999: {
            allowTouchMove: false
          },
          0: {
            allowTouchMove: true
          }
        }
      });
    }

    const wheelVariants = document.querySelectorAll('.wheel__variants')

    if (wheelVariants) {
      let activeIndex = 0
      const changeActive = (index) => {
        wheelVariants.forEach(variant => {
          const wheelButtons = variant.querySelectorAll('.wheel-variant')
          wheelButtons[activeIndex].classList.remove('wheel-variant--active')
        })
        activeIndex = index
        wheelVariants.forEach(variant => {
          const wheelButtons = variant.querySelectorAll('.wheel-variant')
          wheelButtons[activeIndex].classList.add('wheel-variant--active')
        })
      }

      wheelVariants.forEach(variant => {
        const wheelButtons = variant.querySelectorAll('.wheel-variant')
        wheelButtons[0].classList.add('wheel-variant--active')
        wheelButtons?.forEach((button, index) => {
          button.addEventListener('click', () => {
            changeActive(index)
          })
        })
      })

    }

    window.updateWheelSlider = () => {
      wheelSlider.destroy()
      initSlider()
      paginations = wheelPagination.querySelectorAll('.thumbs__item')
      if (activeIndex === 0) {
        startTimeout()
        createPagination()
      }
      wheelSlider.slideTo(1)

      wheelSlider.on('slideChange', (e) => {
        paginations[activeIndex].classList.remove('thumbs__item--active')
        setTimeout(() => {
          activeIndex = wheelSlider.realIndex
          paginations[activeIndex].classList.add('thumbs__item--active')
        }, 1000)
        startTimeout()
        if (innerWidth <= 999) scrollBlock()
      })
      startTimeout()
    }

    let slideChange
    let throttle = false

    const startTimeout = () => {
      clearTimeout(slideChange)
      if (throttle) {
        slideChange = setTimeout(() => {
          throttle = false
          wheelSlider.slideNext()
        }, 30000)
      } else {
        slideChange = setTimeout(() => {
          wheelSlider.slideNext()
        }, 10000)
      }
    }

    navNext.addEventListener('click', () => throttle = true)
    navPrev.addEventListener('click', () => throttle = true)
    wheelSlider.on('touchMove', () => throttle = true)
    updateWheelSlider()

  }

})
